<template>
  <div v-if="group" class="" style="height: 89.5vh;">
    <spinner-round :isLoading="loading" v-if="!loading"></spinner-round>
    <sticky class="page-header sticky-page-header">
      <span slot="left-title">Édition d'un Groupe
      </span>
      <a slot="right-content" @click="$router.goBack(route)" class="button is-white">
        <span class="icon is-small">
          <i class="fal fa-arrow-left"></i>
        </span>
        <span>Retour</span>
      </a>
    </sticky>
    <div class="columns is-gapless contained-height-inter" v-if="!loading">
      <div class="columns is-column column is-8 is-border-right is-padding-top-small">
        <div
          class="column columns is-gapless is-multiline is-vcentered is-narrow is-padding-top-large is-padding-bottom-large">
          <div class="column is-paddingless-left is-paddingless-bottom is-paddingless-top is-narrow">
            <avatar :item="group"></avatar>
          </div>
          <div class="column is-paddingless is-narrow">
            <span><h3 class="title has-text-weight-bold is-padding-left-xsmall">
              <router-link :to="{name: 'UserVue', params: {id: group.pk}}">{{group.first_name}} {{group.last_name}}</router-link>
            </h3></span>
            <p v-if="group.company">
              <router-link :to="{name: 'CompanyVue', params: {id: group.company.pk}}"
                           class="has-text-grey is-padding-left-xsmall">{{group.company_name}}
              </router-link>
            </p>
          </div>
          <div v-if="group.company" class="column is-paddingless is-padding-left-small is-narrow">
          </div>
        </div>
        <div class="column is-narrow is-padding-bottom-xsmall is-border-bottom" v-if="group.sellers && group.sellers.length">
          <p class="label">Membre(s) du groupe <span
            class="tag has-text-weight-normal is-xsmall is-primary is-margin-left-xsmall">{{group.sellers.length}}</span>
          </p>
        </div>
        <div class="column inner-scroll is-padding-top-small" v-if="group.sellers && group.sellers.length">
          <transition-group enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
            <div class="columns is-vcentered column is-paddingless is-margin-bottom-small is-border"
                 v-for="(u, i) in group.sellers" :key="u.user">
              <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
                <avatar :item="u" :i="i"></avatar>
              </div>
              <div
                class="column is-padding-top-xsmall is-padding-bottom-xsmall is-paddingless-left is-paddingless-right is-size-4">
                {{u.first_name}} {{u.last_name}}<br><span class="has-text-grey is-size-5">{{u.email}}</span>
              </div>
              <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall actions">
                <a @click="deleteUser(u, i)" class="button is-circle">
                  <i class="fal fa-trash-alt"></i>
                </a>
              </div>
            </div>
          </transition-group>
        </div>
        <div v-else>
          <div class="column is-narrow is-padding-top-large is-padding-bottom-large">
            <div class="notification is-warning">
              <span class="is-size-5">Aucun membre dans le groupe<br></span>
              <span class="is-size-6">Ajouter depuis la liste ci-contre</span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-column column is-4">
        <div class="column is-narrow is-paddingless field is-marginless" id="filtername">
          <div class="control">
            <v-input name="filtername" @input="val => filterName = val" :model="filterName"
                     v-validate="'min:2'" :errors-bag="errors" data-vv-value-path="val"
                     placeholder="Saisir un utilisateur"
                     data-vv-as="Recherche utilisateur" v-if="showSearch" :classes="'is-degrad-info'">
            </v-input>
          </div>
          <a @click="filterName = null; showSearch = null"><i class="fal fa-times fa-lg"></i></a>
        </div>
        <div class="column is-narrow is-paddingless is-tab-like is-border-bottom columns is-gapless is-vcentered">
          <div class="column">
            <a class="button is-white is-transform-none is-padding-left-small is-padding-right-small"
               :class="{'is-active' : tab === 'users'}" @click="tab = 'users'">Vendeurs</a>
            <!-- <a class="button is-white is-transform-none is-padding-left-small is-padding-right-small">Groupes</a> -->
          </div>
          <div class="column is-narrow">
            <a class="button is-white is-min-width-0 is-padding-left-small is-padding-right-small">
              <span class="icon is-small"><a @click="showSearch = !showSearch; filterName = null"><i
                class="fal fa-search"></i></a></span>
            </a>
          </div>
        </div>
        <div class="column is-paddingless inner-scroll liste-users">
          <ul>
            <li class="columns is-vcentered column is-paddingless is-border-bottom"
                v-for="(seller, i) in filteredSellers"
                :key="seller.pk">
              <div class="column is-narrow is-padding-top-xsmall is-padding-bottom-xsmall">
                <avatar :item="seller" :i="i"></avatar>
              </div>
              <div
                class="column is-padding-top-xsmall is-padding-bottom-xsmall is-paddingless-left is-paddingless-right is-size-4 is-overflow-hidden is-nowrap hover-degrad">
                {{seller.first_name}} {{seller.last_name}}<br><span
                class="has-text-grey is-size-5">{{seller.email}}</span>
              </div>
              <div class="column is-narrow actions is-padding-top-xsmall is-padding-bottom-xsmall on-hover">
                <a @click="addUser(seller, i)" class="button is-circle">
                  <i class="fal fa-plus"></i>
                </a>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { debounce } from 'lodash'

  export default {
    name: 'GroupVue',
    data () {
      return {
        group: null,
        loading: false,
        userLoading: false,
        filterName: null,
        showSearch: false,
        tab: 'users',
        newName: false,
        groupPk: this.$route.params.id,
        freeSellers: [],
        route: this.$route
      }
    },
    computed: {
      g () {
        return this.group
      },
      filteredSellers () {
        let groupUsersPk = this.g.sellers.map(e => e.user)
        return this.freeSellers.filter(el => {
          if (!groupUsersPk.includes(el.pk)) {
            return el
          }
        })
      },
      getFreeSellersFilters () {
        let filters = {
          has_manager: 0
        }
        if (this.g.company) {
          filters.company = this.g.company.pk
          filters.profil_type = 'seller_ext'
        } else {
          filters.profil_type = 'seller'
        }
        return filters
      }
    },
    watch: {
      filterName (value) {
        this.getFreeSellersFiltersDebounce(value)
      }
    },
    methods: {
      getGroup () {
        this.loading = true
        this.$api.userService.getOne(this.groupPk).then(r => {
          this.loading = false
          this.group = r.data
          this.getFreeSellers()
        })
      },
      getFreeSellers () {
        this.$api.userService.get(this.getFreeSellersFilters).then(r => {
          this.freeSellers = r.data.items
        })
      },
      getUsers () {
        if (Array.isArray(this.g.users) && this.g.users.length) {
          this.g.users.map(e => this.$api.userService.getOne(e.pk).then(r => this.users.push(r.data)))
        }
      },
      getFreeSellersFiltersDebounce: debounce(function (query = null) {
        if (query === null) return this.getFreeSellers()
        let params = Object.assign(this.getFreeSellersFilters, {firstName: query, last_name: query})
        this.$api.userService.get(params).then(r => {
          this.freeSellers = r.data.items
        })
      }, 500),
      addUser (user, idx) {
        this.$api.groupService.post(this.g.pk, {user: user.pk}).then(r => {
          this.g.sellers.unshift(r.data)
          this.$notify({
            type: 'is-success',
            text: 'Le vendeur a bien été ajouté au groupe.'
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Impossible d\'ajouter ce vendeur à ce groupe.'
          })
        })
      },
      deleteUser (user, idx) {
        const userId = user.user || user.pk
        this.$api.groupService.delete(this.g.pk, userId).then(r => {
          user.pk = user.user
          this.g.sellers.splice(idx, 1)
          // this.users.push(user)
          this.$notify({
            type: 'is-success',
            text: 'Utilisateur supprimé du groupe'
          })
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de la suppression de l\'utilisateur'
          })
        })
      },
      initGroupVue () {
        this.getGroup()
      }
    },
    created () {
      this.initGroupVue()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/group/GroupVue.vue